module.exports = __webpack_public_path__ + "img/IMG_9000_L_Wood.13bfb8dd.jpg";